// conversion id enum

export enum LinkedInConversionId {
  SignUp = 19502785,
  RequestDemo = 19502793,
  StartToCreateDataset = 19502801,
}

export function trackLinkedInConversion(
  conversionId: LinkedInConversionId,
): void {
  if ("lintrk" in window && typeof window.lintrk === "function") {
    window.lintrk!("track", { conversion_id: conversionId });
  } else {
    console.warn("missing linktrk function");
  }
}
